import { useContext, useState } from "react";
import { NotificacionContext } from "../context/notificacion_context";
import { services } from "../services/api";

export const useLicenciasConducir = () => {
  const notification = useContext(NotificacionContext);
  const [loader, setLoader] = useState(false);
  const [state, setState] = useState({
    licencia: "",
    curp: "",
    correo: "",
    nombre: "",
    status: 0,
    alertMess: "",
    showCard: false,
    pdfBase64: "",
    lineaCaptura: "",
    token: "",
    time: "",
  });

  const [validate, setValidate] = useState({
    ecurp: true,
    ecorreo: true,
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    setValidate((prevState) => ({
      ...prevState,
      ["e" + name]: validateRules(name, value),
    }));
  };

  const validateRules = (name, value) => {
    const curpRegex = /^[A-Z]{4}\d{6}[HM][A-Z]{5}[A-Z0-9]\d$/;
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const rules = {
      curp: value.length !== 18 || !curpRegex.test(value.toUpperCase()),
      correo: !emailRegex.test(value),
    };
    return rules[name] ?? true;
  };

  const handleValidateRules = () => {
    const validationMessages = {
      ecurp: "Por favor ingrese una CURP válida",
      ecorreo: "Por favor ingrese un correo válido",
    };

    for (const [field, message] of Object.entries(validationMessages)) {
      if (validate[field]) {
        notification.showNotification(
          "warning",
          "Campo inválido",
          message,
          null,
          4,
        );
        return true;
      }
    }

    return false;
  };

  const handleConsulta = async () => {
    if (state.licencia === "" || state.curp === "" || state.correo === "") {
      notification.showNotification(
        "warning",
        "Campos Vacíos",
        "Por favor rellene todos los campos requeridos",
        null,
        4,
      );
      return;
    }

    if (handleValidateRules()) return;

    const body = {
      numero_licencia: state.licencia,
      curp: state.curp,
      correo: state.correo,
    };

    setLoader(true);
    const response = await services("POST", "licencias/validar-licencia", body);
    setLoader(false);
    if (response.status !== 200) {
      notification.showNotification(
        "error",
        "Error",
        response?.error ?? response?.data?.message,
        null,
        4,
      );
      return;
    }
    const data = response?.data;
    const status = data?.TP_CONSULTA === 1 ? 0 : data?.estatus;
    setState((prevState) => ({
      ...prevState,
      showCard: true,
      status,
      alertMess: data?.message || data?.mensage,
      urlPayLC: data?.intento,
      lineaCaptura: data?.lcaptura,
      token: data?.tkn,
      nombre: data?.nombre,
      time: data?.time,
    }));
  };

  const handleActionButton = () => {
    if (state.status === 1 && state.urlPayLC) {
      window.open(
        "validarpago/" + state.urlPayLC.split("validarpago/")[1],
        "_blank",
        'noopener'
      );
      return;
    }
    if (state.status === 2) {
      handleDownload();
      return;
    }
    handleGenLC();
  };

  const handleGenLC = async () => {
    setLoader(true);
    const body = {
      numero_licencia: state.licencia,
      nombre: state.nombre,
      curp: state.curp,
      email: state.correo,
      tkn: state.token,
      time: state.time,
    };
    const response = await services("POST", "licencias/generar-linea", body);
    setLoader(false);
    if (response.status !== 200) {
      notification.showNotification(
        "error",
        response.status,
        response.data,
        null,
        4,
      );
      return;
    }
    const data = response?.data;
    setState((prevState) => ({
      ...prevState,
      alertMess: data?.mensaje,
      urlPayLC: data?.intento,
      status: 1,
    }));
  };

  const handleDownload = async () => {
    setLoader(true);
    const body = {
      lcaptura: state.lineaCaptura,
      tkn: state.token,
    };
    const response = await services("POST", "licencias/descargar", body);
    setLoader(false);
    if (response.status !== 200) {
      notification.showNotification("error", "ERROR", response?.data, null, 4);
      if (state.pdfBase64) downLoadPDF(state.pdfBase64);
      return;
    }
    downLoadPDF(response?.data);
  };

  const downLoadPDF = (pdfBase64) => {
    const pdfSrc = `data:application/pdf;base64,${pdfBase64}`;
    const link = document.createElement("a");
    link.href = pdfSrc;
    link.download = "documento.pdf";
    link.click();
    setState((prevState) => ({
      ...prevState,
      pdfBase64,
    }));
  };

  const handleClear = () => {
    setState((prevState) => ({
      ...prevState,
      licencia: "",
      curp: "",
      correo: "",
      nombre: "",
      status: 0,
      alertMess: "",
      showCard: false,
      pdfBase64: "",
      lineaCaptura: "",
      token: "",
      time: "",
    }));
  };

  return {
    state,
    validate,
    loader,
    handleInputChange,
    handleConsulta,
    handleClear,
    handleActionButton,
  };
};
